<pr-add-service-code
  [commonCodes]="data.commonCodes"
  (codeSelected)="onCodeSelected($event)"
/>
